<template>
  <v-app id="inspire">
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <v-container fluid  align-start>

        <v-row >
          <v-col md="12" lg="12" cols="12">
            <v-tabs
                v-model="tab"
                centered
                dark
                icons-and-text
                background-color="#6D9886"
                color="#393E46"
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-qr">
                Leer QR
                <v-icon>fas fa-qrcode</v-icon>
              </v-tab>

              <v-tab href="#tab-lista">
                Ver Lista
                <v-icon>fas fa-clipboard-list</v-icon>
              </v-tab>
              <v-tab-item  key="tab-lista" value="tab-lista">

                <v-row>
                  <v-col md="12" lg="12" cols="12">
                    <v-card  color="#393E46">
                      <v-card-title>Evento a Marcar</v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col md="3" lg="3" cols="12">
                            <v-autocomplete
                                v-model="idevento"
                                :items="eventos"
                                item-text="nombre"
                                item-value="id"
                                label="Escoge Evento"
                                @change="damelistas"
                                persistent-hint
                                single-line
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-data-table
                :headers="headers"
                :items="listas"
                class="elevation-1"
                sort-by="id"
                sort-desc
                :search="search"
                :loading="progr"
                no-data-text="No hay datos disponibles para mostrar."
                no-results-text="No hay resultados para la búsqueda."
                loading-text="Cargando... Por favor espere."
                style="background-color: #393E46;"
            >
              <template v-slot:top>
                <v-toolbar
                    flat
                >
                  <v-toolbar-title>Lista</v-toolbar-title>
                  <v-progress-circular
                      indeterminate
                      v-if="progr == true"
                      color="primary"
                  ></v-progress-circular>
                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialogdelete" persistent max-width="350">
                    <v-card>
                      <v-card-title class="headline">Desea eliminar esta persona de la Fiesta?</v-card-title>
                      <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="close">No</v-btn>
                        <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-switch v-model="item.ingreso" label="Ingreso" @click="marcar(item)" ></v-switch>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="damelistas">Cargar de Nuevo</v-btn>
              </template>
            </v-data-table>
              </v-tab-item>
              <v-tab-item key="tab-qr" value="tab-qr">
                <v-card :color="color">
                  <v-card-title>
                    Leer QR
                  </v-card-title>
                  <v-card-text >
                    <p class="decode-result" style="color:white; background-color: #393E46;">{{ result }}</p>

                    <p class="decode-result" style="color:white; background-color: black;">{{ nombre }}</p>
                    <p class="decode-result" style="color:white; background-color: black;">{{ dni }}</p>

                    <p class="decode-result" style="color:white; background-color: black;">{{ fiesta }} - {{ zona }} - {{ tipo }} </p>
                    <p class="error">{{ error }}</p>


                    <qrcode-stream  @decode="onDecode" @init="onInit">
                    </qrcode-stream>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>

      </v-container>
    </v-main>
    <piepagina/>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";

export default {
  components: {
    cabecera,
    piepagina,

  },
  data: () => ({
    overlay: false,
    tab: null,
    idnegocio: '',
    idevento: 0,
    idtipolista: 0,
    eventos:[],
    tiposlista: [],
    bajaremos: [],
    columns : [
      {
        label: "Nombre",
        field: "nombre",
      },
      {
        label: "DNI",
        field: "dni",
      },
      {
        label: "Promotor",
        field: "promotor",
      },
    ],
    progr: true,
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    dialog: false,
    dialogdelete: false,
    camera: 'auto',
    result: null,
    error: '',
    color: '#393E46',
    menu1: false,
    nombre:'',
    dni:'',
    fiesta:'',
    tipo:'',
    zona:'',
    listas: [],
    search: '',
    editedIndex: -1,
    editedItem: {
      listaDetalleId: 0,
      listaDTO:{
        listaId:0,
        listaTitular:'',
        promotorId: 0,
        promotorNombre:'',
        promotorCabezaId:0,
        promotorCabezaNombre:'',
        negocioId:0,
        negocioNombre:'',
        fiestaId:0,
        fiestaNombre:'',
        fiestaFecha: null,
        fiestaActiva:true,
        tipoListaId:0,
        tipoListaNombre: '',
        clienteId:0,
        clienteNombre:'',
        diaId:0,
        diaNombre:''
      },
      nombre: '',
      dni: '',
      fechaIngreso: '',
      f: true,
      dateCreated: null
    },
    defaultItem: {
      listaDetalleId: 0,
      listaDTO:{
        listaId:0,
        listaTitular:'',
        promotorId: 0,
        promotorNombre:'',
        promotorCabezaId:0,
        promotorCabezaNombre:'',
        negocioId:0,
        negocioNombre:'',
        fiestaId:0,
        fiestaNombre:'',
        fiestaFecha: null,
        fiestaActiva:true,
        tipoListaId:0,
        tipoListaNombre: '',
        clienteId:0,
        clienteNombre:'',
        diaId:0,
        diaNombre:''
      },
      nombre: '',
      dni: '',
      fechaIngreso: '',
      f: true,
      dateCreated: null
    },
    headers: [
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Nombre', align: 'left',  value: 'nombre'},
      { text: 'Tipo de Lista', value: 'tipoLista' },
    ]
  }),
  mounted (){
      this.damelistas();
      this.dameeventos();

  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods : {

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        } else if (error.name === 'InsecureContextError') {
          this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.error = `ERROR: Camera error (${error.name})`;
        }
      }
    },

    async onDecode (content) {
      var bodyFormData = new FormData();
      bodyFormData.append("codigoUnico",content);
      bodyFormData.append("eventoId",this.idevento);
      let url = "tickets/qrcode"
      this.overlay = true
      axios
          .post(url,bodyFormData)
          .then(response => {
            this.result = response.data.ingresado
            this.color = response.data.color
            this.nombre = 'Nombre: '+ response.data.nombre
            this.dni = 'DNI: '+ response.data.dni
            this.fiesta= 'Evento '+ response.data.evento
            this.zona = 'Zona '+ response.data.zona
            this.tipo = 'Tipo: ' + response.data.entrada
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false
            console.log(error);
          });
      this.pause()
      await this.timeout(500)
      this.unpause()
    },

    unpause () {
      this.camera = 'auto'
    },

    pause () {
      this.camera = 'off'
    },

    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    dameeventos(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'actos/eventos/activos/' + this.cliente.tag ;
      axios
          .get(urlfiesta)
          .then(response => {
            this.eventos = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.damelistas();
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
            this.progr = false;
          });
    },
    damelistas(){
      this.progr = true;
      this.overlay = true
      axios
          .get('tickets/evento/todos/'+this.idevento)
          .then(response => {
            this.listas = response.data
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
            this.progr = false;
          });
    },
    marcar (item) {
      var bodyFormData = new FormData();
      bodyFormData.append('codigo', item.codigoUnico);
      this.overlay = true
      axios
          .post('lista/ingreso',bodyFormData)
          .then(response => {
            this.listas = response.data.filter(x=>x.nombre.trim() !== "" )
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      cliente: "cliente"
    })
  }
};
</script>